import {
  END_CTA_FLOW,
  END_CUSTOM_THUMBNAIL_FLOW,
  END_VIDEO_SETTINGS_FLOW,
  FINISH_THUMBNAIL_SAVE,
  INITIATE_THUMBNAIL_SAVE,
  SET_LOCAL_THUMBNAIL,
  START_CTA_FLOW,
  START_CUSTOM_THUMBNAIL_FLOW,
  START_VIDEO_SETTINGS_FLOW,
  TOGGLE_THUMBNAIL_UPLOADING,
} from 'constants/actions';

const DEFAULT_STATE = {
  thumbnail_flow: false,
  cta_flow: false,
  video_settings_flow: false,
  thumbnail_data: {
    thumbnail_local: null,
    initiate_save: false,
    uploading: false,
    og_dims: null,
  },
};

const editorReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case START_CUSTOM_THUMBNAIL_FLOW:
      return { ...state, thumbnail_flow: true };
    case END_CUSTOM_THUMBNAIL_FLOW:
      return { ...state, thumbnail_flow: false };
    case START_CTA_FLOW:
      return { ...state, cta_flow: true };
    case END_CTA_FLOW:
      return { ...state, cta_flow: false };
    case START_VIDEO_SETTINGS_FLOW:
      return { ...state, video_settings_flow: true };
    case END_VIDEO_SETTINGS_FLOW:
      return { ...state, video_settings_flow: false };
    case SET_LOCAL_THUMBNAIL:
      return {
        ...state,
        thumbnail_data: {
          ...state.thumbnail_data,
          thumbnail_local: action.url,
          og_dims: action.dims,
        },
      };
    case INITIATE_THUMBNAIL_SAVE:
      return {
        ...state,
        thumbnail_data: {
          ...state.thumbnail_data,
          initiate_save: true,
        },
      };
    case TOGGLE_THUMBNAIL_UPLOADING:
      return {
        ...state,
        thumbnail_data: {
          ...state.thumbnail_data,
          uploading: !state.thumbnail_data.uploading,
        },
      };
    case FINISH_THUMBNAIL_SAVE:
      return {
        ...state,
        thumbnail_flow: false,
        thumbnail_data: DEFAULT_STATE.thumbnail_data,
      };
    default:
      return state;
  }
};

export default editorReducer;
